<p-toast></p-toast>
<p-confirmdialog />
<p-panel [toggleable]="true">
  <ng-template #header>
    <div class="flex items-center gap-3 w-full">
      <span class="font-semibold">{{ headerTitle() }}</span>
      @if (form.value.is_included) {
        <p-tag
          severity="success"
          [value]="'catalog.tickets.included' | translate"
        />
      } @else {
        <p-tag
          severity="warn"
          [value]="'catalog.tickets.notIncluded' | translate"
        />
      }
      @if (isDirty()) {
        <p-tag severity="warn" value="●" />
      }
    </div>
  </ng-template>

  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="flex flex-col gap-4"
  >
    <div class="flex flex-col gap-3" formArrayName="details">
      @for (group of details.controls; track group; let i = $index) {
        <div
          [formGroupName]="i"
          class="flex items-end gap-3 p-3 rounded border surface-border"
        >
          <div class="flex flex-col flex-1">
            <label class="text-sm mb-1">
              {{ labelForLanguage(group.get('language')?.value) }}
            </label>
            <input pInputText formControlName="title" [maxlength]="255" />
            @if (group.get('title')?.touched && group.get('title')?.invalid) {
              <small class="text-red-500 mt-1">
                {{ 'validation.required' | translate }}
              </small>
            }
          </div>
          @if (group.get('language')?.value !== defaultLanguage) {
            <button
              pButton
              type="button"
              icon="fa fa-trash"
              text
              rounded
              severity="secondary"
              [attr.aria-label]="'catalog.tickets.translation.remove' | translate"
              (click)="removeLanguageRow(i)"
            ></button>
          }
        </div>
      }
      <div class="flex items-center gap-2">
        <p-select
          [formControl]="languagePickerControl"
          [options]="availableLanguages()"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'catalog.tickets.translation.addPlaceholder' | translate"
          [disabled]="availableLanguages().length === 0"
          appendTo="body"
        />
        <p-button
          type="button"
          size="small"
          icon="fa fa-plus"
          [label]="'catalog.tickets.translation.add' | translate"
          [disabled]="!hasPendingLanguage()"
          (onClick)="addLanguageRow()"
        />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div class="flex flex-col">
        <label class="text-sm mb-1">
          {{ 'catalog.tickets.fields.minAmount' | translate }}
        </label>
        <p-inputnumber formControlName="min_amount" [min]="0" />
      </div>
      <div class="flex flex-col">
        <label class="text-sm mb-1">
          {{ 'catalog.tickets.fields.maxAmount' | translate }}
        </label>
        <p-inputnumber formControlName="max_amount" [min]="0" />
      </div>
      <div class="flex items-center gap-3 mt-5">
        <p-toggleswitch formControlName="is_included" />
        <label class="text-sm">
          {{ 'catalog.tickets.fields.isIncluded' | translate }}
        </label>
      </div>
    </div>

    <div class="flex justify-between items-center pt-2">
      <p-button
        type="button"
        size="small"
        severity="danger"
        icon="fa fa-trash"
        [label]="'label.delete' | translate"
        (onClick)="onDelete($event)"
      />
      <p-button
        type="submit"
        size="small"
        [label]="'label.save' | translate"
        [loading]="submitting()"
        [disabled]="!form.valid"
      />
    </div>
  </form>

  @if (isPersisted() && current()) {
    <div class="mt-5 pt-4 border-t surface-border">
      <app-price-history
        [owner]="{ type: 'ticket', id: current()!.id }"
        [prices]="prices()"
        (priceCreated)="reload()"
        (priceDeleted)="reload()"
      />
    </div>
  }
</p-panel>
